module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.switch-group')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "md": 18,
      "lg": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "switch-groups",
      "entity": _vm.switchGroup,
      "fields": _vm.fields,
      "beforeSubmit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-switches')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "switches",
      "columns": ['controllerName', 'name'],
      "isSelected": _vm.isSwitchSelected
    },
    on: {
      "selection-change": _vm.switchSelectChanged
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7395da7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch-group/SwitchGroupDetails.vue
// module id = 1168
// module chunks = 2